import React from 'react';
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../i8n/useI18n";
import ShopHeroSection from "../sections/shop/hero/ShopHeroSection";
import ShopCatalogSection from "../sections/shop/catalog/ShopCatalogSection";

const ShopPage = () => {
    const { t } = useI18n();
    const { category } = useParams<{ category?: string }>();

    return (
        <>
            <Helmet>
                <title>{t("shopPage.hero.title")} | {t("brand.name")}</title>
                <meta name="description" content={t("shopPage.hero.description")} />
            </Helmet>
            <ShopHeroSection category={category} />
            <ShopCatalogSection category={category} />
        </>
    );
};

export default ShopPage;
